import { interpolateColors } from "./interpolateColors";

export default interpolateColors;
